import Carrier from 'carrier-client-vue'

export default ({ endpoint }) => {
  return new Carrier(endpoint, {
    websocket: false
  })
}